<template>
	<gc-dialog
		:title="title"
		:show.sync="visible"
		:show-footer="status != -1"
		:append-to-body="true"
		@ok="handleOk"
		@cancel="visible = false"
		@close="visible = false"
	>
		<el-form v-if="status != -1" ref="form" :model="form" :rules="formRules" label-position="top">
			<el-form-item v-if="status == 0" label="审核结果" prop="reviewStatus">
				<el-radio-group v-model="form.reviewStatus">
					<el-radio :label="1">审核通过</el-radio>
					<el-radio :label="2">审核不通过</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="审核意见" prop="reviewOpinion">
				<el-input
					size="small"
					v-model="form.reviewOpinion"
					type="textarea"
					:rows="3"
					resize="none"
					placeholder="请输入审核意见"
				></el-input>
			</el-form-item>
		</el-form>

		<template v-if="status != 1">
			<h2 v-if="status != -1" class="title">设备明细</h2>
			<gc-table
				style="height: 350px"
				:columns="columns"
				:table-data="tableData"
				:border="true"
				:showPage="true"
				:total="page.total"
				:page-size="page.size"
				:current-page.sync="page.current"
				@size-change="handleSizeChange"
				@current-page-change="handleCurrentPageChange"
			></gc-table>
		</template>
	</gc-dialog>
</template>

<script>
import { ruleRequired, ruleMaxLength } from '@/utils/rules'
import { apiBatchTaskDeviceList, apiBatchTaskReview } from '@/apis/batchDirectiveManage.api.js'

export default {
	name: 'CheckDialog',
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		status: {
			type: [String, Number],
			default: '',
		},
		detail: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			form: {
				reviewStatus: 1,
				reviewOpinion: '',
			},
			formRules: {
				reviewStatus: [ruleRequired('审核结果不能为空')],
				reviewOpinion: [ruleRequired('请填写审核意见'), ruleMaxLength(200)],
			},
			columns: [{ key: 'deviceNo', name: '设备通讯编号' }],
			tableData: [],
			page: {
				size: 20,
				total: 0,
				current: 1,
			},
		}
	},
	computed: {
		visible: {
			get() {
				return this.show
			},
			set(val) {
				this.$emit('update:show', val)
			},
		},
		title() {
			const titleMap = {
				0: '审核下发',
				1: '取消审核',
				'-1': '设备明细',
			}
			return titleMap[this.status]
		},
	},
	watch: {
		show(val) {
			if (!val) {
				this.form = this.$options.data().form
				this.$refs.form?.resetFields()
			} else {
				this.getDeviceList(1)
			}
		},
	},
	methods: {
		getDeviceList(current) {
			if (this.status == 1) return
			this.page.current = current
			apiBatchTaskDeviceList({
				taskNo: this.detail.taskNo,
				size: this.page.size,
				current,
			}).then((res = {}) => {
				this.page.total = res.total
				this.tableData = res.records || []
			})
		},
		handleSizeChange(size) {
			this.page.size = size
			this.getDeviceList(1)
		},
		handleCurrentPageChange(currentPage) {
			this.getDeviceList(currentPage)
		},
		handleOk() {
			let flag = false
			this.$refs.form.validate(valid => {
				flag = valid
			})
			if (!flag) return
			if (this.status == 0 && this.form.reviewStatus == 1) {
				this.$confirm('请先做单表指令下发确认终端功能无误后再提交审核', '提示', {
					showCancelButton: false,
					confirmButtonText: '知道了',
				}).then(() => {
					this.handleCheck()
				})
			} else {
				this.handleCheck()
			}
		},
		handleCheck() {
			const params = {
				taskNo: this.detail?.taskNo,
				...this.form,
			}
			if (this.status == 1) {
				params.reviewStatus = 3
			}
			apiBatchTaskReview(params)
				.then(() => {
					this.$message.success(this.status == 0 ? '审核下发成功！' : '取消审核成功！')
					this.visible = false
					this.$emit('update')
				})
				.catch(err => {
					console.error(err)
				})
		},
	},
}
</script>
<style lang="scss" scoped>
::v-deep {
	.el-input__suffix-inner .iconfont {
		font-size: 22px;
		cursor: pointer;
	}
}
.title {
	margin-bottom: 10px;
	font-size: 16px;
	font-weight: 500;
	color: #4d4d4d;
}
</style>
